export enum PayementsTab {
  All = "All",
  Pending = "Pending",
  Paid = "Paid",
  NeedingConfirmation = "NeedingConfirmation",
}
